/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivateIamUserRequest
 */
export interface ActivateIamUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivateIamUserRequest
     */
    iamUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateIamUserRequest
     */
    updatedBy: string;
}

export function ActivateIamUserRequestFromJSON(json: any): ActivateIamUserRequest {
    return ActivateIamUserRequestFromJSONTyped(json, false);
}

export function ActivateIamUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateIamUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserId': json['iam_user_id'],
        'updatedBy': json['updated_by'],
    };
}

export function ActivateIamUserRequestToJSON(value?: ActivateIamUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_id': value.iamUserId,
        'updated_by': value.updatedBy,
    };
}


